import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import TableService from "../../../Services/QRCodeServices/TableSerivce/TableService";
import toast from "react-hot-toast";
import { AddTable } from "../table/AddTable";
import { TableCard } from "../table/TableCard";
import { OrderDetailsModal } from "../table/OrderDetailsModal";
import { SwitchTableCard } from "../table/SwitchTableCard";

const TableSwitch = ({
  toggle,
  isOpen,
  initialTable,
  onSwitch,
  fetchOrderedItems,
 
}) => {
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  console.log("🚀 ~ TableSwitch ~ selectedTable:", selectedTable);

  const orderRefId = initialTable?.menuOrder?.orderRef?.toString() ?? "";

  useEffect(() => {
    fetchTables();
  }, []);

  // fetch all tables
  const fetchTables = async () => {
    try {
      const data = await TableService.getList();
      setTables(data);
    } catch (error) {
      console.error("Error fetching tables:", error);
      toast.error("Failed to fetch tables");
    }
  };

  // only show available tables
  const availableTables = tables.filter(
    (table) => !table.isOccupied && table.isActive
  );

  // confirm switch
  const handleConfirmSwitch = async () => {
    if (!selectedTable) {
      toast.error("Please select a table to switch");
      return;
    }
    try {
      await TableService.switchtable(orderRefId, selectedTable?.id);
      toast.success(`Switched to ${selectedTable.identification}`);
      fetchTables();
      fetchOrderedItems();
      onSwitch?.(selectedTable);
      toggle();
    } catch (error) {
      console.log(error);
      toast.error("Failed to switch table");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" >
      <ModalHeader toggle={toggle}>Switch Table</ModalHeader>
      <ModalBody>
        <Container fluid>
          {/* Current + New Table Display */}
          <Row>
            <Col lg={4}>
              <Row className="align-items-center">
                <Col md={12} className="mb-2">
                  <div className="p-3 bg-light rounded shadow-sm text-center">
                    <h6 className="fw-semibold mb-1">Current Table</h6>
                    <p className="mb-0 text-primary fw-bold fs-5">
                      {initialTable?.label || "N/A"}
                    </p>
                  </div>
                </Col>
                <Col md={12} className="text-center mb-2">
                  <i class="bx bx-sort-alt-2 fs-4"></i>{" "}
                </Col>
                <Col md={12}>
                  <div
                    className={`p-3 rounded shadow-sm text-center ${
                      selectedTable ? "bg-success bg-opacity-10" : "bg-light"
                    }`}
                  >
                    <h6 className="fw-semibold mb-1">New Table</h6>
                    <p
                      className={`mb-0 fw-bold fs-5 ${
                        selectedTable ? "text-success" : "text-muted"
                      }`}
                    >
                      {selectedTable?.identification || "Not Selected"}
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={8} className="">
              <h5 className="fw-semibold mb-3">Available Tables</h5>
              <Row>
                {availableTables.length > 0 ? (
                  availableTables.map((table) => (
                    <Col key={table.id} lg={2} md={3} sm={3} xs={4}>
                      <SwitchTableCard
                        table={table}
                        onClick={() => setSelectedTable(table)}
                        isSelected={selectedTable?.id === table.id}
                      />
                    </Col>
                  ))
                ) : (
                  <Col>
                    <p className="text-muted">No available tables.</p>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>

          {/* Available Tables */}

          {/* Action Buttons */}
          <Row className="mt-4">
            <Col className="text-end">
              <Button color="secondary" onClick={toggle} className="me-2">
                Cancel
              </Button>
              <Button
                color="primary"
                onClick={handleConfirmSwitch}
                disabled={!selectedTable}
              >
                Confirm Switch
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default TableSwitch;
